<div class="page-header clearfix" *ngIf="hasData()">
  <h1 class="page-header__title">Deploys</h1>
  <ab-time-dur-switch
    class="page-header__element"
    [enabled]="enabled && !featureDisabled && hasData()"
    [dur]="dur"
    [lastN]="lastN"
  ></ab-time-dur-switch>
</div>
<div class="alerts-container">
  <ab-alerts-common></ab-alerts-common>
  <ab-outdated-notifier-warning-alert
    *ngIf="hasData()"
    [projectId]="project.id"
  ></ab-outdated-notifier-warning-alert>
</div>
<div class="flex-grow-1 content-mask-container">
  <div class="container-fluid pt-3">
    <div class="content-mask" *ngIf="featureDisabled">
      <div class="content-mask__content">
        <p class="content-mask__text">
          This Dashboard is showing sample data. Enable the Deploy Dashboard to
          see an overview of all your deploys with detailed analytics.
        </p>
        <button
          class="btn btn--upgrade"
          (click)="openUpgradeModal($event)"
          data-feature="deploy_dashboard"
          type="button"
        >
          Enable The Deploy Dashboard
        </button>
      </div>
    </div>
    <div class="row" *ngIf="featureDisabled !== undefined">
      <div [ngClass]="{ 'col-lg-8': hasData(), 'col-lg-12': !hasData() }">
        <ab-deploy-list
          [chartType]="chartType"
          [dur]="dur"
          [environment]="environment"
          [featureDisabled]="featureDisabled"
          [lastN]="lastN"
          [page]="page"
          [project]="project"
          [emptyProject]="emptyProject"
          (loadingChanged)="onLoading($event)"
        ></ab-deploy-list>
      </div>
      <div class="col-lg-4" *ngIf="hasData()">
        <h4>Deploys over time</h4>
        <ab-deploy-column
          [project]="project"
          [dur]="dur"
          [lastN]="lastN"
          [featureDisabled]="featureDisabled"
          (loadingChanged)="onLoading($event)"
        ></ab-deploy-column>
      </div>
    </div>
  </div>
</div>
